import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { black, TypographyBrand } from '../../../getLPTheme';
import { Grid } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SportsGolfIcon from '@mui/icons-material/SportsGolf';

export default function Introduccion() {
  return (
  <Box>
    <Box sx={{display: {xs: 'none', sm: 'grid', md: 'grid', lg: 'grid', xl: 'grid'}}}>  
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Box sx={{width: "100%"}}>
            <TypographyBrand id="introduccion" textAlign="center" color='white' sx={{fontSize: { sm: "2.5vw"}}}>
              Sabemos que los golfistas para acceder a descuentos, oportunidades exclusivas <br/> y participar en torneos selectos tienen que asociarse a un club tradicional.
            </TypographyBrand>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <TypographyBrand textAlign="center" color='white' sx={{pt:2, fontSize: { sm: "2.5vw"}}}>
              En world golf club:
            </TypographyBrand>
          </Box>
        </Grid>
        <Grid item xs={12}>
        <Box sx={{direction:"row", justifyContent:"center", alignItems:"center", display: "flex"}}>
            <Box sx={{}}>
              <TypographyBrand textAlign="left" color='white' sx={{pt:2, pb:4, fontSize: {sm: "2.5vw"}}}>             
                <List sx={{ textAlign: "center" }}>
                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Tenés beneficios en miles de clubes"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>

                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Vas a encontrar compañeros de juego"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>

                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Vas a acceder a campos exclusivos"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>
                </List>
              </TypographyBrand>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>

    {/* Pantalla Chica */}

    <Box sx={{display: {xs: 'grid', sm: 'none', md: 'none', lg: 'none', xl: 'none'}}}>  
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Box sx={{width: "100%"}}>
            <TypographyBrand id="introduccion" textAlign="center" color='white' sx={{fontSize: { xs: "4.5vw"}}}>
              Sabemos que los golfistas para acceder <br/> a descuentos, oportunidades exclusivas <br/> y participar en torneos selectos tienen <br/> que asociarse a un club tradicional.
            </TypographyBrand>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <TypographyBrand textAlign="center" color='white' sx={{pt:2, fontSize: { xs: "4.5vw"}}}>
              En world golf club:
            </TypographyBrand>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{direction:"row", justifyContent:"center", alignItems:"center", display: "flex"}}>
            <Box sx={{}}>
              <TypographyBrand textAlign="left" color='white' sx={{pt:0, fontSize: {xs: "4.5vw"}}}>             
                <List sx={{ textAlign: "center" }}>
                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Tenés beneficios en miles de clubes"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>

                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Vas a encontrar compañeros de juego"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>

                  <ListItem sx={{ justifyContent: "center" }}>
                    <ListItemIcon sx={{ minWidth: "auto", mr: 2 }}>
                      <SportsGolfIcon sx={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Vas a acceder a campos exclusivos"
                      primaryTypographyProps={{ color: "white", fontSize: { sm: "2.5vw" } }}
                    />
                  </ListItem>
                </List>
              </TypographyBrand>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>

  </Box>
  );
}
